<template>
    <div class="equipment">
        <div class="wx_box">
            <div class="wx_main">
                <div class="top">
                    <div class="wx_title">
                        <span>设备设施</span>
                    </div>
                </div>
                <div class="search_box">
                    <el-input placeholder="请输入内容,按回车即可搜索" v-model="tabPage.keyword" class="input-with-select" size="medium" @change="search()">
                        <div class="searchIcon" slot="prepend"><img src="../../assets/images/search.png" alt=""></div>	
						
                    </el-input>
                    <el-button class="addBtn" @click="addShow = true" v-if="user_position_code<300">新增工具</el-button>
                </div>
                <table class="my_table">
                    <thead>
                        <tr>
                            <th>名称</th>
                            <th>生产厂家</th>
                            <th width="140">单价</th>
                            <th width="70">数量</th>
                            <th width="130">总价 (元)</th>
							<th width="190">工具情况</th>
                            <th width="190">新增时间</th>
                            <th width="90">图片</th>
                            <th width="170">操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in tableData" :key="'table'+index">
                            <td>{{item.name}}</td>
                            <td>{{item.company}}</td>
                            <td>{{item.unit_price}}</td>
                            <td>{{item.stock_number}}{{item.units}}</td>
                            <td>{{item.stock_number*item.unit_price}}</td>
							<td><span v-if="item.type==1">新投入</span><span v-else>原有设施(不计入成本)</span></td>
                            <td>{{item.created_at}}</td>
                            <td><img :src="item.image" @click="jump(item.image)" ></td>
                            <td v-if="user_position_code<300">
                                <el-button class="edit_btn" type="primary" plain size="small" @click="edit(item)">编辑</el-button>
                                <el-button class="del_btn" type="danger" plain size="small" @click="deleteDevice(item.id)">删除</el-button>
                            </td>
							<td v-else>
							    <el-button class="edit_btn" type="primary" plain size="small" >无操作</el-button>
							   
							</td>
                        </tr>
                    </tbody>
                </table>
                <div class="pagination">
                <el-pagination v-show="total>0"  @size-change="handleSizeChange" @current-change="handleCurrentChange"     :current-page="tabPage.currentPage" :page-size="tabPage.pagesize"  :total="total"></el-pagination>
                  </div>
            </div>
        </div>
        <!--        删除弹窗-->
        <WxMessageBox :show="delShow" @save="delsave" @canse="delcanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你是否确定删除此项，删除后，</p>
                    <p>将不可恢复！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--        点击确定弹窗-->
        <WxMessageBox :show="determineShow" @save="determinesave" @canse="determinecanse">
            <div slot="content">
                <p class="word">你是否确定本次操作！</p>
            </div>
        </WxMessageBox>
        <!--        新增工具-->
        <WxMessageBox :show="addShow" @save="addSave" @canse="addCanse">
            <div slot="content">
				
				<el-form :model="form" :rules="rules" ref="form" label-width="0px">
                <div class="wx_form">
                    <div class="form_item">
                        <span class="label">名称：</span>
                        <div class="input">
							<el-form-item label="" prop="name">
                            <el-input v-model="form.name" size="mini"></el-input>
							</el-form-item>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="label">生产厂家:</span>
                        <div class="input">
							<el-form-item label="" prop="company">
                            <el-input v-model="form.company" size="mini"></el-input>
							</el-form-item>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="label">单价:</span>
                        <div class="input w70">
							<el-form-item label="" prop="unit_price">
                            <el-input v-model="form.unit_price" size="mini"></el-input>
							</el-form-item>
                        </div>
                        <span class="subLabel">元</span>
                    </div>
                    <div class="form_item">
                        <span class="label">数量:</span>
                        <div class="input w70">
							<el-form-item label="" prop="stock_number">
                            <el-input v-model="form.stock_number" size="mini"></el-input>
							</el-form-item>
                        </div>
                        <span class="label paddLeft">单位:</span>
                        <div class="input w70">
							<el-form-item label="" prop="units">
                            <el-input v-model="form.units" size="mini"></el-input>
							</el-form-item>
                        </div>
                    </div>
					<div class="form_item">
					    <span class="label">工具情况：</span>
					    <div class="input">
							<el-form-item label="" prop="type">
								<el-select v-model="form.type" size="mini" placeholder="请选择">
								    <el-option
								      v-for="item in toolOptions"
								      :key="item.id"
								      :label="item.value"
								      :value="item.id">
								    </el-option>
								  </el-select>
							</el-form-item>
					    </div>
					</div>
                    <div class="form_item flexTop">
                        <span class="label">图片上传:</span>
                        <div class="input">
							<el-form-item label="" prop="image">
                            <!-- <el-upload
							 class="avatar-uploader"
                                    :action="uploadAction"
									 :headers="myHeaders"
                                    :show-file-list="false"
									:file-list="fileList"
                                    :on-success="handleSuccess"
									 :on-preview="handlePreview"
                                    :before-upload="beforeUpload">
                                <img v-if="fileList.length>0" :src="form.image" class="avatar" style="width: 100px; height: 100px;">
                                <div class="unloadIcon" v-else></div>
								
                            </el-upload> -->
							<el-upload
							  class="avatar-uploader"
							         :action="uploadAction"
							  		:headers="myHeaders"
									list-type="picture-card"
							  		:file-list="fileList"
									:limit="1" 
							         :on-success="handleSuccess"
							  		:on-preview="handlePreview"
							         :before-upload="beforeUpload">
							</el-upload>
							<el-dialog :visible.sync="dialogVisible" :modal="false">
							  <img width="100%" :src="form.image" alt="">
							</el-dialog>
							</el-form-item>
                        </div>
                    </div>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
		<el-dialog title="图片" :visible.sync="dialogVisibleImg" width="60%" height="100%" class="dialogVisibleImg">
			<el-carousel height="500px" :autoplay="false">
				
					<img :src="image" alt=""  style="width: 100%;">
				
			</el-carousel>
		</el-dialog>
    </div>
</template>

<script>
	import {saveFarmDevice,getFarmDevice,deleteFarmOther} from '@/api/api'
    import WxMessageBox from '@/components/MessageBox';
	import {
		getFarmInfo
	} from '@/api/api'
		import axios from 'axios';
    export default {
        name: "equipment",
        data(){
            return{
				uploadAction: axios.defaults.baseURL + "/upload/image",
				myHeaders: {
					authorization: "Bear " + localStorage.getItem("token")
				},
				user_position_code:'',
				farm_id:'',
				delete_id:'',
                total:0,
                tableData:[],
                tabPage:{
					keyword:'',
                    currentPage:1, // 初始页
                    pagesize:10,    // 每页的数据
                },
                delShow:false,
				dialogVisibleImg:false,
				image:'',
				dialogVisible:false,
                determineShow:false,
                addShow:false,
                fileList:[],
                form:{
					id:'',
                    name:'',
                    company:'',
                    unit_price:'',
                    stock_number:'',
					type:'',
                    units:'',
					image:'',
					
                },
				rules: {
					name: [{
						required: true,
						message: '请输入设备设施名称',
						trigger: 'blur'
					}],
					company: [{
						required: true,
						message: '请输入生产厂家',
						trigger: 'blur'
					}],
					unit_price: [{
						required: true,
						message: '请输入单价',
						trigger: 'blur'
					}],
					stock_number: [{
						required: true,
						message: '请输入数量',
						trigger: 'blur'
					}],
					units: [{
						required: true,
						message: '请输入单位',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请选择工具情况',
						trigger: 'change'
					}],
					image: [{
						required: true,
						message: '请上传图片',
						trigger: 'blur'
					}],
				
				},
				toolValue:'',
				toolOptions:[
					{id: 1,value: '新投入'},
					{id: 2,value: '原有设施（不计入购买成本）'},
				]
			}
        },
		mounted() {
				this.farm_id=this.$route.params.id
				getFarmInfo(this.$route.params.id).then(resp => {
				
				     this.user_position_code=resp.user_position_code
					if(resp.farm.is_check==1){
						this.get_farm_device()
					}else{
						this.$message.error("请先完善农事管理板块相关申请工作，才能开通此板块！")
						this.$router.push("/park/detail/"+this.$route.params.id)
					}
					})
				
		},
        methods:{
			  handlePreview(file) {
					this.dialogVisible = true
			        console.log(file);
			      },
			get_farm_device(){
			 getFarmDevice(this.farm_id,this.tabPage).then(resp=>{
				    this.tableData=resp.data
					this.total=resp.total
			 })
			 },
            // 表格斑马纹
            tableRowClassName({row, rowIndex}) {
                if (rowIndex % 2 !== 1) {
                    return 'single-row';
                }else{
                    return 'double-row';
                }
            },
            // 分页
            handleSizeChange: function (size) {
                this.tabPage.pagesize = size;
            },
            handleCurrentChange: function(currentPage){
                this.tabPage.currentPage = currentPage;
				this.get_farm_device(this.farm_id,this.tabPage)
            },
			search(){
				this.get_farm_device(this.farm_id,this.tabPage)
			},
            // 删除弹窗确定
            delsave(){
                this.delShow = false
                this.$nextTick(()=>{
                    this.determineShow = true
                })
            },
			jump(imgs) {
				//this.imgList = imgs
				this.image=imgs
				this.dialogVisibleImg = true
			},
            // 删除弹窗取消
            delcanse(){
                this.delShow = false
            },
            // 点击确定弹窗确认
            determinesave(){		
				deleteFarmOther(this.delete_id,"farm_device","delete_farm_device").then(resp=>{
									 if(resp.status==1){
									 this.$message.success(resp.msg)
									 this.get_farm_device(this.farm_id,this.tabPage)
									 this.determineShow = false 
									 }else{
										 this.$message.error(resp.msg)
									 }
				})
                
				
            },
            // 点击确定弹窗取消
            determinecanse(){
				
                this.determineShow = false
            },
			edit(item){
				this.form=item
				this.addShow=true
				this.fileList.push({url:item.image})
			},
			deleteDevice(id){
				this.delete_id=id
				this.delShow=true
			},
            // 新增工具弹窗确认
            addSave(){
				this.$refs["form"].validate((valid) => {
					if (valid) {
						 saveFarmDevice(this.farm_id,this.form).then(resp=>{
													
				              this.$message.success("操作成功");
							  this.get_farm_device(this.farm_id,this.tabPage)
							   this.addShow = false
							   this.form=this.$options.data().form
							   this.fileList=[]
							 //  this.$refs["from"].resetFields();
							//this.$refs.form.resetFields()
							
							this.clearFrom()
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
               
            },
            // 新增工具弹窗取消
            addCanse(){
                this.addShow = false
			     this.clearFrom()
            },
			clearFrom(){
	/* 			this.form["id"]=''
				this.form["name"]=''
				this.form["company"]=''
				this.form["unit_price"]=''
				this.form["stock_number"]=''
				this.form["type"]=''
				this.form["units"]=''
				this.form["image"]='' */
				this.form={}
				this.fileList=[]
			//	this.$refs.form.resetFields()
		// this.get_farm_device(this.farm_id,this.tabPage)
			},
			
            handleSuccess(res, file, fileList) {
              //  this.imgUrl = URL.createObjectURL(file.raw);
			  this.fileList = fileList
				// this.fileList.push({url:res.data})
				this.form["image"]=res.data
            },
            // 编辑、添加人员上传
            beforeUpload(file) {
              const isJPG = file.type === 'image/jpeg';
               const isPng = file.type === 'image/png';
              				 const isLt2M = file.size / 1024 / 1024 < 2;
              				 if (!isLt2M) {
              				     this.$message.error('上传头像图片大小不能超过 2MB!');
              				 }
               if (!isJPG && !isPng) {
              					
                   this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
                  return false
              }else{
                	return true
              }
            },
        },
        components: {
            WxMessageBox
        }
    }
</script>

<style lang="less">
    .equipment {
        .wx_box {
            .wx_main {
                background:radial-gradient(rgba(19, 62, 173, 0.74),rgba(5, 18, 32, 0.47));
                background-size: cover;
                padding: 11px 35px 50px 24px;
                .top {
                    overflow: hidden;
                }
                .search_box{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 30px;
                    .input-with-select{
                        width: 318px;
                        .el-input-group__append, .el-input-group__prepend{
                            background: rgba(45, 153, 255, 0.3);
                        }
                    }
                    .addBtn{
                        width: 150px;
                        height: 40px;
                        line-height: 40px;
                        border: 1px solid #2D99FF;
                        background-color: transparent;
                        font-size: 18px;
                        font-weight: 400;
                        color: #2D99FF;
                        padding: 0;
                        border-radius: 0;
                    }
                }
                .my_table{
                    margin-top: 25px;
                    tr{
                        td{
                            img{
                                width: 66px;
                                height: 36px;
                            }
                        }
                    }
                }
            }
        }
        .avatar-uploader {
            width: 70px;
            height: 70px;
            border-radius: 6px;
            border: 1px solid rgba(45, 153, 255, 0.48);
			position: relative;
			background: url("../../assets/images/upLoad_02.png") no-repeat center center;
			background-size: 41px 41px;
			display: flex;
            .el-upload-list{
                width: 70px;
                height: 70px;
            }
			.el-upload-list--picture-card .el-upload-list__item{
				width: 70px;
				height: 70px;
			}
			.el-upload-list__item-actions{
				width: 70px;
				height: 70px;
			}
            
			.el-upload--picture-card{
				width: 70px;
				height: 70px;
				border-radius: 0;
				border: 0;
				margin: 0 auto;
				background-color: transparent;
			}
        }
    }
</style>
